import Swal from 'sweetalert2';
import { getAxiosClient } from '~src/api';
import { getState } from '~src/state';
import { isLoggedUserGlobalEditor } from '~src/user';
import { handleTabTemplates } from '~src/sidebar/index';

export const createTemplatesCategory = async (event) => {
  event.preventDefault();
  event.stopPropagation();

  const projectType = getState('selected.tipo');

  const { value: name } = await Swal.fire({
    title: 'Come vuoi chiamare questa nuova tipologia di evento?',
    input: 'text',
    inputAttributes: {
      autocapitalize: 'on',
    },
    inputValidator: (value) => {
      if (!value) {
        return 'Inserisci un nome';
      }
    },
    showCancelButton: true,
    showLoaderOnConfirm: true,
    reverseButtons: true,
    confirmButtonColor: '#278e8e',
    confirmButtonText: 'Avanti &rarr;',
    progressSteps: ['1'],
  });

  if (!name) {
    return;
  }

  Swal.fire({
    title: 'Salvataggio in corso',
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    willOpen: () => {
      Swal.showLoading();
    },
  });

  const httpClient = await getAxiosClient();

  const data = {
    name: name,
    order: 100, // Scelto alto perche li gestiamo a mano
  };

  let tableName;

  const isGlobalEditor = await isLoggedUserGlobalEditor();

  if (isGlobalEditor === false) {
    tableName = 'editor_templates_categories';
  } else {
    data.isGlobal = true;
    tableName = 'editor_templates_categories_default';
  }

  if (projectType.isGlobal === true) {
    data.editor_project_types_default_pointer = projectType.objectId;
  } else {
    data.editor_project_types_pointer = projectType.objectId;
  }

  try {
    const response = await httpClient.post(
      `${process.env.PARSE_API_URL}/${tableName}`,
      { data }
    );
    if (response.status !== 200) {
      return Swal.fire({
        icon: 'error',
        title: 'Qualcosa &egrave; andato storto',
        html: 'Il salvataggio &egrave; fallito. Si prega di riprovare',
        confirmButtonColor: '#278e8e',
      });
    } else {
      await Swal.fire({
        icon: 'success',
        title: 'Tutto pronto!',
        text: 'Nuova tipologia di evento salvata correttamente!',
        confirmButtonColor: '#278e8e',
      });

      await handleTabTemplates(true);
    }
  } catch (error) {
    return Swal.fire({
      icon: 'error',
      title: 'Qualcosa &egrave; andato storto',
      html: 'Il salvataggio &egrave; fallito. Si prega di riprovare',
      footer: `Errore: <strong>${error.message}</strong>`,
      confirmButtonColor: '#278e8e',
    });
  }
};
